import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {
  CommunityTypeDistributionData,
  CommunityTypeCount,
} from '../../types/reports';

interface CommunityCounts {
  ordained: number;
  nonOrdained: number;
  candidate: number;
}

interface ActivePDPsTableProps {
  eccData: CommunityTypeDistributionData;
}

function ActivePDPsTable({ eccData }: ActivePDPsTableProps): JSX.Element {
  const { t } = useTranslation();

  const getCommunityCounts = (community: string): CommunityCounts => {
    const ordained = eccData.ordained.find((item) => item.community === community)?.count || 0;
    const nonOrdained = eccData.nonOrdained.find((item) => item.community === community)?.count || 0;
    const candidate = eccData.candidate.find((item) => item.community === community)?.count || 0;
    return { ordained, nonOrdained, candidate };
  };

  return (
    <Table responsive striped>
      <thead>
        <tr className="linktableheader">
          <th>{t('Community')}</th>
          <th>{t('Ordained')}</th>
          <th>{t('Non Ordained')}</th>
          <th>{t('Candidate')}</th>
        </tr>
      </thead>
      <tbody>
        {eccData.ordained.map((community: CommunityTypeCount) => {
          const { ordained, nonOrdained, candidate } = getCommunityCounts(community.community);
          return (
            <tr key={`${community.community}`}>
              <td>{community.community}</td>
              <td>{ordained}</td>
              <td>{nonOrdained}</td>
              <td>{candidate}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}

export default ActivePDPsTable;
